import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {Design, Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Form} from '@mintdata-wsp/wsp/ui/components/forms/data/Form';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {ErrorPopupSide, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {InputField} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {SpaceSelector, ISpaceSelectortMenuItem} from '../views/workspace/home/filters/SpaceSelector';

const styles = require('./AddDesignDialog.less');
const cx = classnames.bind(styles);

interface IAddDesignDialogState
{
    designName:string;
    selectedSpace:Project;
    apiErrorMessage:string;
}

@observer
export class AddDesignDialog extends React.Component<any, IAddDesignDialogState>
{
    private _form:Form = new Form();

    constructor(props:any)
    {
        super(props);
        this.state = {
            designName: '',
            selectedSpace: rootState.ui.mainPage.currentProject,
            apiErrorMessage: null
        };
    }

    @bind
    _onCreateDesign()
    {
        let {designName} = this.state;

        const {createAppEditor, currentProject} = rootState.ui.mainPage;

        let {selectedSpace} = this.state;

        if( !selectedSpace )
            selectedSpace = rootState.ui.mainPage.currentProject || rootState.data.projects[0];

        createAppEditor.serverError = null;

        if( !designName || !designName.trim() || !selectedSpace || createAppEditor.isCreationAppInProgress )
        {
            this._validateForm();
            return;
        }

        this.setState({apiErrorMessage: null});
        createAppEditor.isCreationAppInProgress = true;

        controllers.data.designs.createNewDesign(selectedSpace, designName.trim())
            .then(action((design:Design) =>
            {
                createAppEditor.isVisible = false;
                createAppEditor.isCreationAppInProgress = false;

                const {currentOrganization} = rootState.userSession;

                controllers.analytics.main.trackEvent(
                    AnalyticsEventActions.WSP_DESIGN_CREATED,
                    {
                        org_sid: currentOrganization.siteId,
                        org_name: currentOrganization.name,

                        space_id: selectedSpace.id,
                        space_name: selectedSpace.name,

                        design_id: design.id,
                        design_name: design.name
                    }
                );

                controllers.ui.dialogs.hideDialog(Dialogs.AddDesign);

                if( !currentProject || selectedSpace.id !== currentProject.id )
                    controllers.navigation.toProject(selectedSpace.id)

            }))
            .catch(action((message:string | any) =>
            {
                this.setState({apiErrorMessage: message}, () =>
                {
                    this._validateForm();
                });

                if( message )
                    createAppEditor.serverError = message;

                createAppEditor.isCreationAppInProgress = false;
            }));

        // controllers.data.projects.createProject(designName, 'some desc ' + Math.random())
        //     .then((newProject:Project) =>
        //     {
        //         const {currentOrganization} = rootState.userSession;
        //
        //         controllers.analytics.main.trackEvent(
        //             AnalyticsEvents.WSP_SPACE_CREATED,
        //             {
        //                 org_sid: currentOrganization.siteId,
        //                 org_name: currentOrganization.name,
        //
        //                 space_id: newProject.id,
        //                 space_name: newProject.name
        //             }
        //         );
        //
        //         controllers.ui.dialogs.hideDialog(Dialogs.AddDesign);
        //         controllers.ui.mainPage.selectProject(newProject);
        //     });
    }

    private _validateForm = () =>
    {
        const fields = ['designName'];

        this._form.getFields(fields).forEach(field =>
        {
            field.elementRef.checkIsValid();
        });
    };

    @bind
    _onDesignNameChanged(newValue:string)
    {
        this.setState({designName: newValue});
    }

    @bind
    private _handleClose():void
    {
        controllers.ui.dialogs.hideDialog(Dialogs.AddDesign);
    }

    @bind
    private _onSelectSpace(item:ISpaceSelectortMenuItem):void
    {
        this.setState({
            selectedSpace: rootState.data.projects.find(({id}) => id === item.spaceId),
            apiErrorMessage: null
        }, () => this._validateForm());
    }

    render()
    {
        const {designName, apiErrorMessage} = this.state;

        const {currentProject} = rootState.ui.mainPage;

        const selectedSpace = this.state.selectedSpace || currentProject;

        return (
            <Dialog
                title={'New design'}
                onClose={this._handleClose}
            >
                <Column className={cx('contentColumn')}>
                    <InputField
                        label={''}
                        // icon={MDIcons.common.PhotoFilter}
                        style={InputStyle.Dialog}
                        placeholder={'Enter design name'}
                        errorPopupSide={ErrorPopupSide.Bottom}
                        isValidFn={(value:string) =>
                        {
                            return value && value.length > 0 && !apiErrorMessage;
                        }}
                        getErrorMessageFn={(value:string) =>
                        {
                            return apiErrorMessage
                                ? apiErrorMessage
                                : `Please enter a name for your design | ( "${value}" was too short )`;
                        }}
                        onChange={this._onDesignNameChanged}
                        onEnterKey={this._onCreateDesign}
                        isInitiallyFocused={true}
                        formKey={'designName'}
                        form={this._form}
                    />
                </Column>
                <Column className={cx('selectColumn')}>
                    <SpaceSelector
                        togglerId="addDesignSpaceSelector"
                        titlePrefix="In "
                        titlePostfix={selectedSpace && selectedSpace.name.toLowerCase().endsWith('space') ? '' : ' space'}
                        className={cx('spaceSelector')}
                        selectedItemClassName={cx('selectedItem')}
                        selectedItem={selectedSpace}
                        onSelectItem={this._onSelectSpace}
                    />
                    <DialogButton
                        caption={'Create design'}
                        onClick={this._onCreateDesign}
                        isDisabled={!designName || designName.trim().length === 0}
                    />
                </Column>
            </Dialog>
        );
    }
}
